import { useEffect, useState } from 'react';
import { getTelemetryClient } from './telemetryClient';

/** Connection + latency snapshot for the live status indicator. */
export default function useConnectionStatus() {
  var client = getTelemetryClient();
  var _state = useState(function () {
    return client.getState();
  });
  var state = _state[0];
  var setState = _state[1];

  useEffect(function () {
    return client.subscribe(setState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    connected: state.connected,
    connecting: state.connecting,
    latency: state.metrics.latency,
    lastUpdate: state.lastUpdate,
    pulseSeq: state.pulseSeq,
  };
}
